<div class="container-card-testimonial {{ classItem }} m-3 no-print" *ngIf="block">
    <div class="container-card-testimonial__image image col-6 d-flex justify-content-center align-items-center position-relative">
        <img loading="lazy" *ngIf="block.foto" [src]="domainWebsite + extractImageSrc(block.foto)" [alt]="block.testo_alt">
        <img loading="lazy" *ngIf="!block.foto" src="../../../../../assets/images/rectangle_gradient.png" alt="gradient-image">
        <div class="container-card-testimonial__text position-absolute bottom-0 left-0">
            <h3 class="container-card-testimonial__text__title ls-h3-section-title " [innerHTML]="block.titolo"></h3>
            <p class="container-card-testimonial__text__role m-0 ls-p-small" [innerHTML]="block.descrizione"></p>
        </div>
        <div *ngIf="block.foto" class="background"></div>
    </div>
    <div class="container-card-testimonial__quote quote col-6">
        <p class="ls-p text-neutral-30" [innerHTML]="block.quote"></p>
    </div>
</div>
<ng-container *ngIf="block">
    <app-sample-print 
        [imageUrl]="block.foto ? domainWebsite + extractImageSrc(block.foto) : ''"
        [title]="block.titolo"
        [subtitle]="block.descrizione"
        [description]="block.quote">
    </app-sample-print>
</ng-container>